import { render } from "./ChatTypingIndicator.vue?vue&type=template&id=1b822ba4&scoped=true"
import script from "./ChatTypingIndicator.vue?vue&type=script&lang=js"
export * from "./ChatTypingIndicator.vue?vue&type=script&lang=js"

import "./ChatTypingIndicator.vue?vue&type=style&index=0&id=1b822ba4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b822ba4"]])

export default __exports__